<template>
    <div>
        <div>
            <div style="color: #000;">
                <H4>{{$t('favorite_searchs')}}</H4>
            </div>
            <div class="icon-close">
                <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
            </div>
        
            <span>{{$t('favorite_searchs_info')}}</span>
            <div style="position: relative; height: 55px; margin-bottom: 10px;">
                <button @click="addkeywordsAlerts" style= "position: absolute; right: 0;" class="btn_1 btn-addkw"> Criar Alerta para Palavras-chave </button>
            </div>
        </div>
        <div class="tableKeyWordsAlerts">
            <b-table :busy.sync="isBusy" small id="listKeyWordsAlerts" :fields="fields" hover :items="keywordsAlerts" :current-page="currentPage" show-empty>
                
                <template v-slot:cell(keywords)="data" @click="() => useInSearch(data.item.keywords)">
                    {{ data.item.keywords }}
                </template>

                <template v-slot:cell(alert)="data">
                    <!-- <b-form-checkbox v-model="data.item.alert" name="check-button" switch disabled size="lg"/> -->
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <b-icon icon="check-circle-fill" variant="success" v-if="data.item.alert" scale="1.5" />
                        <b-icon icon="x-circle-fill" variant="danger" v-if="!data.item.alert" scale="1.5" />
                    </div>
                </template>

                <template v-slot:cell(seeNow)="data">
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <b-icon class="icon" icon="eye-fill" variant="info" @click="() => search(data.item)" scale="0.6"  v-b-tooltip.hover title="Ver Agora" ></b-icon>                        
                    </div>
                </template>    

                <template v-slot:cell(actions)="data">
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <b-icon class="icon" stacked icon="pencil-fill" variant="primary" @click="() => getItem(data.item)" scale="0.6"  v-b-tooltip.hover title="Editar" ></b-icon>                        
                        <b-icon class="icon" stacked icon="trash-fill" variant="danger" @click="() => deleteItem(data.item)" scale="0.6"  v-b-tooltip.hover title="Remover" ></b-icon>
                    </div>
                </template>    
            
                <template slot="empty">
                    <div class="text-center" style="margin-top:125px; color:#1937a0">
                        <b-spinner v-if="isBusy" variant="primary" label="Spinning"></b-spinner>
                        <span v-else>Nenhuma Palavra-chave cadastrada</span>
                    </div>  
                </template>
            </b-table> 
        </div>    
        
        

        <md-dialog :md-active.sync="showDialogAddUpdateKeywordsAlerts" style="z-index:99" id="addUpdateKeywordsAlerts">
            <div class="wrapper-dialog" style="padding:50px 15px; background: #fff !important; width:800px">
                <div class="icon-close">
                    <div @click="showDialogAddUpdateKeywordsAlerts = false" v-b-tooltip.hover title="Fechar">
                        <b-icon stacked icon="x"        scale="1.1"  ></b-icon>
                    </div> 
                </div>

                <div>
                    <b-form class="">
                        <b-form-group
                            id="input-group-1"
                            label="Palavras-Chave:"
                            label-for="input-1"
                            label-class = "label-kw"
                        >
                        <b-form-textarea
                            id="textarea-kw"
                            v-model="keywords"
                            placeholder="Digite as palavras chave..."
                            required
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                        </b-form-group>

                        <b-form-group
                            id="input-group-2"
                            label="Nome do Alerta:"
                            label-for="input-2"
                            label-class = "label-login"
                        >
                            <b-form-input
                                id="input-alert-name"
                                v-model="name"
                                required
                                placeholder="Digite um nome para o alerta"
                                
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-3"
                            label="Alerta:"
                            label-for="input-1"
                            label-class = "label-alert"
                            label-cols-lg="1"
                        >
                            <b-form-checkbox v-model="alert" name="check-button-alert" switch size="lg"  style="padding-top: 3px;"/>
                        </b-form-group>

                         <div class="advancedSearch">
                            Tipo de Busca:
                            <div>
                                <div v-for="(val, key) in typeAdvancedSearch" :key="key" class="radioAdvancedSearch">
                                    <input type="radio" :value="val.value" v-model="selectedAdvancedSearch" :id="val.value" @click="uncheckRadios(val)">
                                    <label :for="val.value">{{ val.text }}</label>
                                </div>
                            </div>
                         </div>

                      

                        <div class="d-flex flex-row-reverse">
                            <b-button  @click="addUpdateItem()" class="">
                                <span v-if="!updateElemt">{{$t('register')}}</span>
                                <span v-if="updateElemt">{{$t('update')}}</span>
                            </b-button>
                        </div>                        
                    </b-form>
                </div>
            </div>
        </md-dialog>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import firebase from '@/firebaseInit.js';
    import i18n from '@/i18n.js'
    import ModalConfirmation from '@/components/ModalConfirmation.vue'
    
    export default {
        name: 'keywordsAlertList',
        components:{
            ModalConfirmation,
        },
        // props: {
        //     searchedWords: String,    
        // },
        mounted() {
          
        },
    
        data() {
            return {
                isBusy : false,
                currentPage: 1,
                fields: [
                    {key: 'keywords',                       label: 'Palavras-Chave', sortable: true},
                    {key: 'alert',                          label: 'Alerta', sortable: true },
                    {key: 'name',                           label: 'Nome do Alerta'   , sortable: true },
                    {key: 'selectedAdvancedSearchString',   label: 'Tipo de Busca do Alerta' },
                    {key: 'seeNow',                           label: 'Ver Agora' },
                    {key: 'actions',                        label: 'Ações'  },
                ],
            
                showDialogAddUpdateKeywordsAlerts: false,
                id:'',
                name : '',
                keywords: '',
                alert: '',
                selectedAdvancedSearchString:'',

                updateElemt: false,
                currentItem: '',
                
                refUsers: firebase.firestore().collection('users'),
            
                showDialogAddUpdateKeywordsAlertsConfirmation: false,

                typeAdvancedSearch:[
                    { text: 'Todas as Palavras (Padrão)', value: 2 },
                    { text: 'Qualquer uma das palavras' , value: 1 },
                    { text: 'Frase exata'               , value: 3 },
                    // { text: 'Inicia com'                , value: 4 },
                ]
                

            };
        },
        computed: {
            rows() {
                return this.keywordsAlerts.length
            },
            ...mapGetters({
                user : "user",
                keywordsAlerts : "keywordsAlerts"
            }),

            selectedAdvancedSearch:{
                get () {
                    return this.$store.state.selectedAdvancedSearch;
                },
                set (value) {
                    this.$store.commit('setSelectedAdvancedSearch', value)
                }
            },

            searchedWords: {
                get () {
                    return this.$store.state.searchedWords
                },
                set (value) {
                    this.$store.commit('setSearchedWords', value)
                }
            }, 
        
        },
        methods:{     
            search(data) {
                this.searchedWords = data.keywords;
                window.search();
                this.closeDialog();
            },
            closeDialog: function(){
                this.$emit('showDialogKeywordsAlerts', false )
            },
            addUpdateItem(){
                if(this.updateElemt){
                    this.updateItem();
                }else {
                    this.addItem() ;
                }                      
            },
            addkeywordsAlerts(){
                this.id         = '';
                this.name       = '';
                this.keywords   = '';
                this.alert      = false;

                this.updateElemt = false;
                this.showDialogAddUpdateKeywordsAlerts = true; 
            },         
            addItem(){
                if(this.keywords==""){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationAlert'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0 btnok',
                        centered: true
                    })
                }
                else if(this.alert && this.name==""){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationAlertOn'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0 btnok',
                        centered: true
                    })
                }else{
                    let item = {
                        name : this.name,
                        keywords: this.keywords, 
                        alert: this.alert,
                        advancedSearch: this.selectedAdvancedSearch,
                    }
                    
                    this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").add(item).then(ref =>{
                        item.id = ref.id;
                        this.showDialogAddUpdateKeywordsAlerts = false;
                        item.selectedAdvancedSearchString = this.mountStringSelectedAdvancedSearch(this.selectedAdvancedSearch);

                        this.$store.commit('addkeywordsAlerts', item)
                    })
                }
            },
            getItem (item) {
                this.currentItem = item;
                this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").doc(item.id).get().then(item => {
                    if(item){
                        
                        this.id = item.id;
                        this.name = item.data().name;
                        this.keywords= item.data().keywords;
                        this.alert= item.data().alert;
                        this.selectedAdvancedSearch = item.data().advancedSearch;
                        this.selectedAdvancedSearchString = this.mountStringSelectedAdvancedSearch(this.selectedAdvancedSearch);
                        this.showDialogAddUpdateKeywordsAlerts = true;
                        this.updateElemt = true;
                    }
                });   
            },
            updateItem(){
                if(this.keywords==""){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationAlert'), {
                        title: i18n.t('msgTitleWarning'),
                        dialogClass:'modalConfirm',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0 btnok',
                        centered: true
                    })
                }else if(this.alert && this.name==""){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationAlertOn'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0 btnok',
                        centered: true
                    })
                }else{
                    let itemUpdated = {  
                        id: this.id, 
                        name : this.name,
                        keywords: this.keywords, 
                        alert: this.alert,
                        advancedSearch: this.selectedAdvancedSearch,
                    }
                
                    this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").doc(this.id).update(itemUpdated);
                    
                    itemUpdated.selectedAdvancedSearchString = this.mountStringSelectedAdvancedSearch(this.selectedAdvancedSearch);

                    let items = {
                        currentItem : this.currentItem,
                        itemUpdated : itemUpdated,
                    }
                    

                    this.$store.commit('updateKeywordsAlerts', items);
                    this.showDialogAddUpdateKeywordsAlerts = false;
                }
                
                
            },
            deleteItem (item) {
                this.$bvModal.msgBoxConfirm(i18n.t('titleConfirmDeleteKeyword'), {
                    title: i18n.t('msgConfirmDeleteKeyword'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: i18n.t('yes'),
                    cancelTitle: i18n.t('no'),
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(confirm => {
                    if(confirm){
                        this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").doc(item.id).delete().then(() => {
                            this.$store.commit('removeKeywordsAlerts',item)
                        }).catch((error) => {
                            alert("Error removing document: ", error);
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },
            useInSearch(keywords){
                this.$emit('useInSearch', keywords );
            },

            uncheckRadios: function (val) {
                this.selectedAdvancedSearch = 2;
            },

            mountStringSelectedAdvancedSearch(option){
                let typeAdvancedSearch = [
                    { text: 'Todas as Palavras'         , value: 2 },
                    { text: 'Qualquer uma das palavras' , value: 1 },
                    { text: 'Frase exata'               , value: 3 },
                    { text: 'Inicia com'                , value: 4 }
                ]
                return typeAdvancedSearch.filter(function(obj, index){return obj.value===option;})[0].text;
            }
        },
        beforeMount() {        
            this.isBusy = true;
            this.selectedAdvancedSearch = 2;
            this.$store.commit('clearkeywordsAlerts');
            this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").get().then(querySnapshot => {
                querySnapshot.forEach(doc => {
                    if(doc){
                        
                        let item = {   
                            id: doc.id,
                            name : doc.data().name,
                            keywords: doc.data().keywords, 
                            alert: doc.data().alert,
                            selectedAdvancedSearch: doc.data().advancedSearch,
                        }
                        if(doc.data().advancedSearch){
                            item.selectedAdvancedSearchString = this.mountStringSelectedAdvancedSearch(doc.data().advancedSearch)
                        }

                        this.$store.commit('addkeywordsAlerts', item)
                    }
                });
                this.isBusy = false;
            }).catch( error => {console.log("erro:" + error)});   
            
            //recebe as palavras chaves digitadas no campo de busca para salvá-las
            if(this.searchedWords && !this.isBusy) {          

                this.showDialogAddUpdateKeywordsAlerts = false;
                this.keywords = this.searchedWords;
            }

          
        },
        
    }
</script>

<style lang="scss" scoped>

  

    


    .dialogConfirmation{
        padding:20px;
        border-radius: 20px;
    }

    .useInSearch{
        cursor: pointer;

        &:hover{
            color:#1937a0;
            text-decoration: underline;
            text-decoration-color: #1937a0;
        }
    }

   

    .btn-addkw{
        color: #fff !important;
        width: 275px;
        height: 35px;
        &:hover{
            color:#fff !important;
        }
    }


    .icon{
        z-index: 99999;
        height: 35px;
        width: 35px;
        border-radius: 20px;
        background-color: #fff;
        border: 2px solid #FFFFFF;
        box-sizing: border-box;
        box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        margin-right: 5px;
        color:#615f5f;
        &:hover{
            background-color: #eee;
        }
    }

    ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff;
        border-color: #1937a0 !important;
        background-color: #1937a0 !important;
    }

    #addUpdateKeywordsAlerts{
        background: rgba(0,0,0,.6);
        z-index: 98;
    }

    .tableKeyWordsAlerts{
        position: relative;
        height: 82%;
        overflow-y: auto;
        table{                        
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
        }
    }

    .advancedSearch{
        font-size: 14px;
        color:#666;
        width: 100%;       
         
        margin-bottom: 15px;

        >div{
            margin-top: 5px;    
            padding:10px;
            border-radius: 25px;
            border: 1px solid #ced4da;
        }

        label{margin:0}
        
    }

    #input-alert-name {
        background-color:#fff; 
        color:#000; 
        border-color: #ced4da;
        &:focus{
             border: 1px solid #ced4da;
        }
        
    }
   
    
</style>